import React              from 'react';
import { useTranslation } from 'react-i18next';

import Alert  from 'components/Alert';
import Button from '@mui/material/Button';
import Grid   from '@mui/material/Grid';

import PropTypes from 'prop-types';


function ResultNotification(props) {

  const { t } = useTranslation();

  if (!props.alert)
    return null;

  return (
    <>
      <Alert alert={props.alert} setAlert={props.reset}/>
      <Grid container justifyContent='center'>
        <Grid item>
          <Button onClick={props.reset}>
            {t('createAnotherRequest')}
          </Button>
        </Grid>
      </Grid>
    </>
  );
}

ResultNotification.propTypes = {
  alert: PropTypes.shape({
    msgTranslKey: PropTypes.string.isRequired,
    type:         PropTypes.string
  }),
  reset: PropTypes.func.isRequired,
};

export default ResultNotification;